import { render, staticRenderFns } from "./CopyTooltip.vue?vue&type=template&id=0b6c2d4a&scoped=true"
import script from "./CopyTooltip.vue?vue&type=script&lang=js"
export * from "./CopyTooltip.vue?vue&type=script&lang=js"
import style0 from "./CopyTooltip.vue?vue&type=style&index=0&id=0b6c2d4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6c2d4a",
  null
  
)

export default component.exports